"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _AutoComplete = _interopRequireDefault(require("../util/AutoComplete"));

var _baseModule = _interopRequireDefault(require("./styles/base.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var LocationBased =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LocationBased, _React$Component);

  function LocationBased(props) {
    var _this;

    _classCallCheck(this, LocationBased);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LocationBased).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "locationSelect", function (id, value) {
      _this.setState({
        id: id,
        value: value
      });

      var onSet = _this.props.onSet;
      onSet({
        queryType: "locationBased",
        id: id,
        name: value
      });
    });

    _this.state = {
      id: "",
      value: ""
    };
    return _this;
  }

  _createClass(LocationBased, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          id = _this$state.id,
          value = _this$state.value;
      return _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement("div", {
        className: _baseModule.default.displayFlex
      }, _react.default.createElement("div", {
        className: _baseModule.default.label
      }, "Trip destination")), _react.default.createElement("input", {
        type: "hidden",
        name: "location_id",
        value: id
      }), _react.default.createElement(_AutoComplete.default, {
        dataSrc: "/ajax/vendors/activity/suggestLocation.php",
        placeholder: "Type here",
        name: "location_text",
        className: _baseModule.default.input,
        style: {
          margin: 0
        },
        value: value || "",
        onSelect: this.locationSelect
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      // do things with nextProps.someProp and prevState.cachedSomeProp
      if (nextProps.enquiryFor.queryType === "locationBased" && nextProps.enquiryFor.id !== prevState.id) {
        return {
          id: nextProps.enquiryFor.id || "",
          value: nextProps.enquiryFor.name
        };
      }

      return null;
    }
  }]);

  return LocationBased;
}(_react.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    enquiryFor: state.enquiryFor
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(LocationBased);

exports.default = _default;